import * as React from "react";
import { forwardRef, useRef, useState } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
const StyledMenuAnchor = styled.div`
  position: fixed;
  width: 0;
  height: 0;
  pointer-events: none;
`;
export const MenuAnchor = forwardRef(
  ({ style = void 0, ...rest }, ref) => createPortal(/* @__PURE__ */ React.createElement(StyledMenuAnchor, { ref, style, ...rest }), document.body)
);
const useClickToOpenMenu = () => {
  const triggerRef = useRef(null);
  const [opened, setOpened] = useState(false);
  const [anchorPosition, setAnchorPosition] = useState(null);
  const onOpenChange = (nextOpened) => {
    var _a;
    setOpened(nextOpened);
    if (!nextOpened) {
      (_a = triggerRef.current) == null ? void 0 : _a.focus({ preventScroll: true });
    }
  };
  const toggleAt = (position) => {
    if (opened) {
      onOpenChange(false);
      return;
    }
    setAnchorPosition(position);
    setOpened(true);
  };
  const onClick = (event) => {
    const { clientX, clientY } = event;
    const hasPointerPosition = clientX !== 0 || clientY !== 0;
    const rect = event.currentTarget.getBoundingClientRect();
    toggleAt(hasPointerPosition ? { x: clientX, y: clientY } : { x: rect.left, y: rect.bottom });
  };
  const onKeyDown = (event) => {
    if (event.target !== event.currentTarget || event.key !== "Enter") {
      return;
    }
    event.preventDefault();
    const rect = event.currentTarget.getBoundingClientRect();
    toggleAt({ x: rect.left, y: rect.bottom });
  };
  return { triggerRef, opened, onOpenChange, anchorPosition, onClick, onKeyDown };
};
export default useClickToOpenMenu;
